import React from 'react';
import { motion } from 'framer-motion';
import SEO, { SEO_CONFIGS } from '../components/SEO';

const Sectors = () => {
  const sectors = [
    {
      name: 'Manufacturing',
      image: 'https://images.unsplash.com/photo-1681263576084-e054b2d89903?q=80&w=800&auto=format&fit=crop',
      description: 'We connect manufacturing organizations with leaders who excel in operational excellence, digital transformation, and sustainable growth. Our expertise spans traditional manufacturing to Industry 4.0 implementations.',
      expertise: ['Operations Leadership', 'Supply Chain Excellence', 'Quality Management', 'Digital Manufacturing', 'Lean & Six Sigma']
    },
    {
      name: 'Engineering',
      image: 'https://images.unsplash.com/photo-1771433050765-72a5eb1658ca?q=80&w=800&auto=format&fit=crop',
      description: 'Our engineering practice focuses on placing technical leaders who drive innovation, manage complex projects, and build high-performing engineering teams across diverse disciplines.',
      expertise: ['R&D Leadership', 'Product Development', 'Technical Architecture', 'Engineering Management', 'Innovation Strategy']
    },
    {
      name: 'Automation',
      image: 'https://images.unsplash.com/photo-1531746790731-6c087fecd65a?q=80&w=800&auto=format&fit=crop',
      description: 'We specialize in identifying automation leaders who understand robotics, AI, and intelligent systems, helping organizations transform through technology.',
      expertise: ['Robotics & AI', 'Process Automation', 'Industrial IoT', 'Smart Manufacturing', 'Control Systems']
    },
    {
      name: 'Fashion & Apparel',
      image: 'https://images.unsplash.com/photo-1762430815620-fcca603c240c?q=80&w=800&auto=format&fit=crop',
      description: 'Our fashion practice connects brands with creative visionaries and operational experts who understand both design excellence and business performance.',
      expertise: ['Design Leadership', 'Brand Management', 'Retail Operations', 'Supply Chain', 'Sustainability']
    },
    {
      name: 'Energy',
      image: 'https://images.unsplash.com/photo-1709620292053-f3dc6420a79a?q=80&w=800&auto=format&fit=crop',
      description: 'We place energy sector leaders who drive the transition to sustainable energy while managing traditional energy operations with excellence.',
      expertise: ['Renewable Energy', 'Power Generation', 'Energy Trading', 'Sustainability', 'Regulatory Affairs']
    },
    {
      name: 'Emerging Technology',
      image: 'https://images.unsplash.com/photo-1769467701165-a83217c13446?q=80&w=800&auto=format&fit=crop',
      description: 'Our technology practice focuses on disruptive tech sectors, placing leaders who understand blockchain, AI, quantum computing, and next-generation platforms.',
      expertise: ['Artificial Intelligence', 'Blockchain', 'Cloud Technologies', 'Cybersecurity', 'Deep Tech']
    }
  ];

  return (
    <div>
      <SEO {...SEO_CONFIGS.sectors} />
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-primary text-white" data-testid="sectors-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl lg:text-6xl font-bold mb-6"
          >
            <span className="gold-text">Sectors</span> We Serve
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-lg text-slate-300 max-w-3xl"
          >
            Deep industry expertise across sectors driving India's economic transformation
          </motion.p>
        </div>
      </section>

      {/* Sectors List */}
      <section className="section-spacing bg-white" data-testid="sectors-list">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-24">
            {sectors.map((sector, index) => (
              <div
                key={index}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
                data-testid={`sector-detail-${index}`}
              >
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <h2 className="text-3xl lg:text-4xl font-bold text-primary mb-4">
                    {sector.name}
                  </h2>
                  <p className="text-muted-foreground leading-relaxed mb-6">
                    {sector.description}
                  </p>
                  <div>
                    <h3 className="text-lg font-semibold text-primary mb-3">Our Expertise:</h3>
                    <div className="flex flex-wrap gap-2">
                      {sector.expertise.map((item, i) => (
                        <span
                          key={i}
                          className="px-4 py-2 bg-muted text-sm font-medium text-primary"
                        >
                          {item}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className={`relative h-96 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <img
                    src={sector.image}
                    alt={sector.name}
                    className="w-full h-full object-cover shadow-xl"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sectors;